import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=c32dbfc8&scoped=true&"
import script from "./UserVerification.vue?vue&type=script&lang=js&"
export * from "./UserVerification.vue?vue&type=script&lang=js&"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=c32dbfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32dbfc8",
  null
  
)

component.options.__file = "UserVerification.vue"
export default component.exports